module.exports = __webpack_public_path__ + "img/decrease.34e8df03.svg";